export default __webpack_public_path__ + "66d668bf85f295247466cbe5d368121e.png";